// extracted by mini-css-extract-plugin
export var dataCell = "_ni-2";
export var dataRow = "_ni-0";
export var headerRow = "_ni-1";